import React from "react";
import cn from "classnames";

import { StyledButton } from "../shared-style";
import { IProps } from "./interfaces";

const Cancel = ({ children, onClick, facebook, google, disabled, className }: IProps) => (
    <StyledButton
        className={cn("button", "button--light", facebook && "FacebookLight", google && "GoogleLight", className)}
        type="button"
        onClick={onClick}
        disabled={disabled}
    >
        {children}
    </StyledButton>
);

export default Cancel;
